import PropTypes from 'prop-types';
export const reviewsWebPropTypes = {
  heading: PropTypes.string,
  text: PropTypes.string,
  items: PropTypes.arrayOf(PropTypes.shape({
    rate: PropTypes.string,
    icon: PropTypes.any,
    text: PropTypes.string
  }))
};